import React from "react";

import useNavigation from "../hooks/useNavigation";
import SchoolMobileHeader from "./SchoolMobileHeader";
import SchoolMobileMenu from "./SchoolMobileMenu";
import SchoolMobileView from "./SchoolMobileView";

import "./SchoolMobileDrawer.css";

const SchoolMobileDrawer = () => {
  const {
    isMenuOpen,
    hasView,
    closeMobileMenu,
  } = useNavigation();

  return (
    <>
      <div
        className={
          isMenuOpen
            ? "school-mobile-backdrop school-mobile-backdrop--open"
            : "school-mobile-backdrop"
        }
        onClick={closeMobileMenu}
      />

      <aside
        className={
          isMenuOpen
            ? "school-mobile-drawer school-mobile-drawer--open"
            : "school-mobile-drawer"
        }
      >
        <SchoolMobileHeader />

        <div className="school-mobile-drawer__body">
          {hasView ? (
            <SchoolMobileView />
          ) : (
            <SchoolMobileMenu />
          )}
        </div>
      </aside>
    </>
  );
};

export default SchoolMobileDrawer;